import { useEffect, useState } from 'react';
import { api } from '../api/client';

const DEMO_CREDENTIALS = {
  email: 'admin@ecocell.com',
  password: 'Demo1234!!',
  tenantSlug: 'ecocell',
};

export function useDemoAutoLogin() {
  const [isReady, setIsReady] = useState(false);
  const isDemo = typeof window !== 'undefined' && window.location.hostname === 'demo.d-pass.eu';

  useEffect(() => {
    if (!isDemo) {
      setIsReady(true);
      return;
    }

    async function autoLogin() {
      try {
        // Check if already authenticated before auto-logging in so that
        // users testing editor/viewer roles are not bumped back to admin.
        const user = await api.getCurrentUser().catch(() => null);
        if (user) {
          setIsReady(true);
          return;
        }
        await api.login(DEMO_CREDENTIALS.email, DEMO_CREDENTIALS.password, DEMO_CREDENTIALS.tenantSlug);
      } catch (err) {
        console.warn('Demo auto-login failed:', err);
      } finally {
        setIsReady(true);
      }
    }

    autoLogin();
  }, [isDemo]);

  return { isDemo, isReady };
}
